/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three to eight metrics read clearly. Too many axes make the chart hard to interpret, and fewer than three collapse the shape.`)
};

const es_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De tres a ocho métricas se leen con claridad. Demasiados ejes dificultan la interpretación del gráfico, y menos de tres colapsan la forma.`)
};

const de_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei bis acht Kennzahlen lesen sich klar. Zu viele Achsen erschweren die Interpretation des Diagramms, und weniger als drei lassen die Form kollabieren.`)
};

const nl_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie tot acht metrics lezen duidelijk. Te veel assen maken de grafiek moeilijk te interpreteren, en minder dan drie laten de vorm inzakken.`)
};

const fr_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois à huit métriques se lisent clairement. Trop d'axes rendent le graphique difficile à interpréter, et moins de trois font s'effondrer la forme.`)
};

const it_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da tre a otto metriche si leggono chiaramente. Troppi assi rendono il grafico difficile da interpretare, e meno di tre fanno collassare la forma.`)
};

const pt_br2_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De três a oito métricas ficam claras. Eixos demais dificultam a interpretação do gráfico, e menos de três colapsam a forma.`)
};

const pt_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três a oito métricas leem-se claramente. Demasiados eixos tornam o gráfico difícil de interpretar, e menos de três colapsam a forma.`)
};

const ja_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3～8個の指標が明確に読み取れます。軸が多すぎるとチャートが読みにくくなり、3個未満だと形が崩れます。`)
};

const zh_radar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三到八个指标最清晰易读。轴数过多会使图表难以解读，少于三个则会使形状塌陷。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_faq_a2", locale)
	if (locale === "en") return en_radar_faq_a2(inputs)
	if (locale === "es") return es_radar_faq_a2(inputs)
	if (locale === "de") return de_radar_faq_a2(inputs)
	if (locale === "nl") return nl_radar_faq_a2(inputs)
	if (locale === "fr") return fr_radar_faq_a2(inputs)
	if (locale === "it") return it_radar_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_radar_faq_a2(inputs)
	if (locale === "pt") return pt_radar_faq_a2(inputs)
	if (locale === "ja") return ja_radar_faq_a2(inputs)
	return zh_radar_faq_a2(inputs)
};